import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CssBaseline, ThemeProvider } from '@mui/material'; // Import CssBaseline and ThemeProvider
import theme from './theme'; // Import your custom theme
import clsx from 'clsx';

ReactDOM.render(
  <React.StrictMode>
    {/* Wrap your app with the ThemeProvider */}
    <ThemeProvider theme={theme}>
      <CssBaseline /> {/* Include CssBaseline */}
      <App />
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
